import filterUtils from '@/mixins/filterUtils'
import { CHANNEL_KPI_LABELS } from '@/utils/campaignOptions'
import { FILTER_MAPPING } from './filterEndpointMapping'

export function parseParams (params) {
  return params
    ? Object.keys(params)
      .filter(key => params[key] !== undefined) // explicit undefined, not null, false, '' or 0
      .map(key => `${key}=${params[key]}`).join('&')
    : ''
}

export function parseUrlFilters (entity, filters) {
  const mapping = FILTER_MAPPING[entity]
  if (!mapping) {
    return ''
  }
  const params = filters
    .filter(f => mapping[f.key] && filterUtils.methods.filterHasValue(f))
    .reduce((acum, f) => {
      if (String(f.value) !== '') {
        const key = mapping[f.key]
        acum[key] = f.value instanceof Date
          ? f.value.toISOString().split('T')[0]
          : String(f.value)
      }
      return acum
    }, {})

  return parseParams(params)
}

export function transformChannelMetrics (data) {
  const kpis = [
    {
      total: 0,
      label: CHANNEL_KPI_LABELS['VISITS'],
      key: 'visits',
      data: []
    },
    {
      total: 0,
      label: CHANNEL_KPI_LABELS['IMPRESSIONS'],
      key: 'impressions',
      data: []
    },
    {
      total: 0,
      label: CHANNEL_KPI_LABELS['CLICKS'],
      key: 'clicks',
      data: []
    },
    {
      total: 0,
      label: `${CHANNEL_KPI_LABELS['CTR']} (%)`,
      key: 'ctr',
      data: []
    }
  ]

  data.sort((a, b) => {
    return new Date(a.date) - new Date(b.date)
  })

  for (const item of data) {
    for (const kpi of kpis) {
      const value = item[`${kpi.key}_count`]
      kpi.total += value
      kpi.data.push({ date: new Date(item.date), value })
    }
  }

  // eslint-disable-next-line
  const [visits, impressions, clicks, ctr] = kpis
  ctr.total = (clicks.total / (impressions.total || 1)) * 100

  return kpis
}
